import axios from "axios";
import { errorHandler } from "./requestFull";
// import * as Sentry from "@sentry/nextjs";
import { getCookie } from "cookies-next";

const request = axios.create({
  withCredentials: false,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json", // Set content type to JSON
  },
});

request.interceptors.request.use(
  (config) => {
    const accessToken = getCookie("access_token");
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${JSON.stringify(accessToken)}`;
    }
    return config;
  },
  (error) => {
    // do something with request error
    return Promise.reject(error);
  }
);
// Add a response interceptor
request.interceptors.response.use((response) => {
  // Handle successful responses
  return response.data;
}, errorHandler);

export default request;
